export const CONTEUDOS_IZINHOS = {
  SUMARIZADORES: "Os sumarizadores apresentam um resumo quantitativo dos itens conforme diferentes critérios de movimentação e filtragem.",
  TOTAL_GERAL: "Todas as combinações distintas de Filial×SKU, incluindo ativos e inativos. " +
    "Total apresenta tudo, enquanto Filtrados corresponde aos filtros que você aplicou.",
  MIX_FILIAIS: "Combinações distintas de Filial×SKU que pertencem ao mix. " +
    "Total apresenta tudo, enquanto Filtrados corresponde aos filtros que você aplicou.",
  MOVIMENTACAO_RETIRADA: "Combinações distintas de Filial×SKU que faturam em uma filial, mas o estoque sai de outra filial. " +
    "Total apresenta tudo, enquanto Filtrados corresponde aos filtros que você aplicou.",
  MOVIMENTACAO_MISTA: "Combinações distintas de Filial×SKU que faturam em uma filial, mas o estoque pode sair da mesma ou de outra filial. " +
    "Total apresenta tudo, enquanto Filtrados corresponde aos filtros que você aplicou.",
  MOVIMENTACAO_PROPRIA: "Combinações distintas de Filial×SKU que o faturamento e a saída do estoque ocorrem na mesma filial. " +
    "Total apresenta tudo, enquanto Filtrados corresponde aos filtros que você aplicou."
};
